import React, { useState, useEffect } from 'react';
import { Radio, Space, Table, Tag, message } from 'antd';
import axios from 'axios';
import { baseUrl } from '../../config/apiConfig';
import moment from 'moment';
import tokenStore from '../../stores/TokenStore';
import { Link } from 'react-router-dom';

const topOptions = [
  { label: 'topLeft', value: 'topLeft' },
  { label: 'topCenter', value: 'topCenter' },
  { label: 'topRight', value: 'topRight' },
  { label: 'none', value: 'none' },
];

const bottomOptions = [
  { label: 'bottomLeft', value: 'bottomLeft' },
  { label: 'bottomCenter', value: 'bottomCenter' },
  { label: 'bottomRight', value: 'bottomRight' },
  { label: 'none', value: 'none' },
];

const columns = [
  {
    title: 'No.',
    dataIndex: 'number',
    key: 'number',
  },
  {
    title: 'Merchant ID',
    dataIndex: 'merchantID',
    key: 'merchantID',
  },
  {
    title: 'Company Name',
    dataIndex: 'CompanyName',
    key: 'CompanyName',
  },
  {
    title: 'Application Time',
    dataIndex: 'applicationTime',
    key: 'applicationTime',
    render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: 'Application Status',
    dataIndex: 'status',
    key: 'status',
    render: (text) => <Tag color={text === 'APPROVED' ? 'success' : 'warning'}>{text}</Tag>,
  },

  // {
  //   title: 'Tags',
  //   key: 'tags',
  //   dataIndex: 'tags',
  //   render: (tags) => (
  //     <span>
  //       {tags.map((tag) => {
  //         let color = tag.length > 5 ? 'geekblue' : 'green';
  //         if (tag === 'loser') {
  //           color = 'volcano';
  //         }
  //         return (
  //           <Tag color={color} key={tag}>
  //             {tag.toUpperCase()}
  //           </Tag>
  //         );
  //       })}
  //     </span>
  //   ),
  // },
  {
    title: 'Detail',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <Link to={`/merchants/detail/${record.id}`}>Details</Link>
      </Space>
    ),
  },
  {
    title: 'Payment QRCode',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        {record.status === 'APPROVED' ? (
          <Link
            to={{
              pathname: `/merchants/payment-qrcode`,
            }}
            state={{
              url: record.codeUrl,
              merchantName: record.abbreviatedCompanyName,
            }}
          >
            Payment QRCode
          </Link>
        ) : (
          <span style={{ color: 'gray', cursor: 'not-allowed' }}>
            Payment QRCode
          </span>
        )}
      </Space>
    ),
  },
];

const MerchantListPage = () => {
  const [data, setData] = useState([]);
  const [bottom, setBottom] = useState('bottomRight');

  useEffect(() => {
    // Fetch merchant data from the API
    axios.post(baseUrl + '/merchant/select_all_merchant_List', {}, {
      headers: {
        token: tokenStore.token,
      },
    })
      .then((response) => {
        if (response.data.code === 200) {
          // Sort the data based on applicationTime in descending order
          const merchants = response.data.data
            .sort((a, b) => new Date(b.applicationTime) - new Date(a.applicationTime))
            .map((merchant, index) => ({
              key: merchant.id,
              number: index + 1,
              merchantID: merchant.merchantId,
              CompanyName: merchant.abbreviatedCompanyName,
              status: merchant.applicationStatus,
              applicationTime: merchant.applicationTime,
              // tags: ['approved'], // You can modify this based on other criteria if needed
              codeUrl: merchant.codeUrl,
              id: merchant.id,
              abbreviatedCompanyName: merchant.abbreviatedCompanyName
            }));
          setData(merchants);
        } else {
          message.error('Failed to fetch merchant data');
        }
      })
      .catch((error) => {
        console.error('Error fetching merchant data:', error);
        message.error('Error fetching merchant data');
      });
  }, []);

  return (
    <div>
      <Table
        columns={columns}
        pagination={{
          position: [bottom],
        }}
        dataSource={data}
      />
    </div>
  );
};

export default MerchantListPage;
